var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tickets-table',{attrs:{"status":_vm.status,"priority":_vm.priority,"title-heading":"h2","owner-id":_vm.ownerId,"bottom-comp":_vm.bComp,"bottom-comp-props":_vm.bCompProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }